import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'

export const Accordion: ComponentStyleConfig = {
  baseStyle: (props: Dict) => ({
    container: {
      borderTop: 'none',
      borderBottomColor: mode(
        'rw1.secondary.light.1',
        'rw1.secondary.dark.1',
      )(props),
      borderBottomWidth: 'thin',
    },
    button: {
      _focus: {
        boxShadow: 'none',
      },
      _hover: {
        backgroundColor: 'inherit',
      },
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 0,
      paddingRight: 0,
    },
    icon: {
      color: mode('rw1.text.light.5', 'rw1.text.dark.5')(props),
    },
  }),
}
